import { useSessionAutoStartAllowed } from "@memorang/ui/components/StudySession/SessionAutoStartContext";
import { TimeOverrunBanner } from "@memorang/ui/components/StudySession/SessionContent/item-types/pte/TimeOverrunBanner";
import { useState } from "react";
import useFormativeItemTimer from "../hooks/useFormativeItemTimer";

const FormativeTimeOverrunContainer = () => {
	const isAutoStartAllowed = useSessionAutoStartAllowed();
	const { isOverrun } = useFormativeItemTimer(!isAutoStartAllowed);
	const [dismissed, setDismissed] = useState(false);

	return (
		<TimeOverrunBanner
			visible={isOverrun && !dismissed}
			onDismiss={() => setDismissed(true)}
		/>
	);
};

export default FormativeTimeOverrunContainer;
